import { Button, Skeleton } from '@capsicum/common-web';

import { S } from './Password.styled';

export const FormWithSkeletons = () => {
	return (
		<S.FormContainer>
			<Skeleton>
				<S.TextInputSkeletonItem />
			</Skeleton>
			<S.ButtonSection>
				<Button disabled fullWidth isLoading testID="withdraw-password-skeletonButton" />
			</S.ButtonSection>
		</S.FormContainer>
	);
};
